export const shouldRequestStoredSheetUrl = (
    visible: boolean,
    sheetUrl: string,
    exporting: boolean,
    legalVerified: boolean,
) => visible && legalVerified && !sheetUrl && !exporting
